// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sensorGallery__BdoAr {
  padding: 15px;
  display: flex;
  flex-direction: column;
  background: var(--inputs-disable-disable-surface);
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  min-width: 0;
  height: 198px;
}

.noImageGallery__OCXTy {
  height: 213px;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.photoIcon__JHreW {
  width: 40px;
  height: 40px;
}

.noImageTitle__Autcx {
  color: var(--tables-secondary-row-sub-title-text);
  display: block;
  text-align: center;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
}

.noImageDescription__D7kxw {
  display: block;
  color: var(--tables-primary-row-text-additional);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.11px;
}

.twoBulletPagination__icK8c .swiper-pagination {
  transform: translateX(-13%) !important;
}
@media (max-width: 1300px) {
  .twoBulletPagination__icK8c .swiper-pagination {
    transform: translateX(-3%) !important;
  }
}

.threeBulletPagination__TDzXS .swiper-pagination {
  transform: translateX(-18%) !important;
}
@media (max-width: 1000px) {
  .threeBulletPagination__TDzXS .swiper-pagination {
    transform: translateX(-6%) !important;
  }
}

.fourBulletPagination__hvugj .swiper-pagination {
  transform: translateX(-23%) !important;
}

.fiveBulletPagination__bVLWm .swiper-pagination {
  transform: translateX(-36%) !important;
}

.gallerySwiper__wgQYv {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.gallerySwiper__wgQYv .swiper-pagination {
  display: flex;
  position: absolute;
  bottom: 0;
  left: 50% !important;
  transform: translateX(-50%);
  z-index: 2;
}
.gallerySwiper__wgQYv .swiper-pagination-bullet {
  min-width: 16px;
  height: 3px;
  display: block;
  padding: 0;
  background: var(--tables-photo-gallery-pagination-default);
  transform: none;
  border: none;
  border-radius: 0;
  box-shadow: none;
  opacity: 1;
  cursor: pointer;
}
.gallerySwiper__wgQYv .swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 11px;
  background: var(--tables-photo-gallery-pagination-active);
  border: none;
  cursor: auto;
}
.gallerySwiper__wgQYv .swiper-pagination-bullet-active-prev-prev,
.gallerySwiper__wgQYv .swiper-pagination-bullet-active-next-next {
  transform: scaleX(0.3);
}

.swiper-wrapper__p23vF {
  box-sizing: border-box;
  height: 100%;
}

.slide__DqsPF {
  box-sizing: border-box;
  height: 144px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.galleryImage__Gi9xq {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.imageItem__Yj0IO {
  position: relative;
  flex: 1;
  height: 100%;
}

.slideLabels__BMU5y {
  position: absolute;
  top: 5px;
  left: 5px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
}

.typeLabel__gtfbm,
.pointLabel___sjNC {
  font-family: Roboto;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  padding: 5px 10px;
  box-shadow: 0 0 1px 0 rgba(12, 26, 75, 0.24), 0 3px 8px -1px rgba(50, 50, 71, 0.05);
  border-radius: 10px;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 100%;
}

.typeLabel__gtfbm {
  color: var(--tables-primary-row-text-main);
  background: var(--segments-chips-toggle-surface-active);
  text-transform: uppercase;
}

.pointLabel___sjNC {
  color: var(--tables-primary-row-text-additional);
  background: var(--segments-chips-toggle-surface-default);
}

.navBtn__aSp3o {
  width: 30px;
  height: 30px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--tables-photo-gallery-surface-arrow);
  border: none;
  position: absolute;
  top: 38%;
  z-index: 1;
  cursor: pointer;
}
.navBtn__aSp3o path {
  stroke: var(--tables-photo-gallery-icon);
}

.prevBtn__a2xt5 {
  left: 0;
  border-radius: 0 2px 2px 0;
}

.prevBtnIcon__obh_B {
  width: 20px;
  height: 20px;
  transform: rotate(180deg);
}
.prevBtnIcon__obh_B path {
  stroke: var(--tables-photo-gallery-icon);
}

.nextBtn__VF3Xd {
  right: 0;
  border-radius: 2px 0 0 2px;
}

.editGalleryButton__RlMYS {
  position: absolute;
  right: 5px;
  top: 5px;
  border-radius: 4px;
  border: 1px solid var(--buttons-stroke);
  background: var(--buttons-text-primary);
  z-index: 1;
  cursor: pointer;
}
.editGalleryButton__RlMYS path {
  fill: var(--buttons-stroke);
}

.skeleton__K9m_q {
  width: 100%;
  height: 198px;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/SensorsList/components/SensorGallery/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,iDAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAzEF;;AA4EA;EACE,cAAA;EACA,gDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAzEF;;AA8EI;EACE,sCAAA;AA3EN;AA6EM;EAHF;IAII,qCAAA;EA1EN;AACF;;AAiFI;EACE,sCAAA;AA9EN;AAgFM;EAHF;IAII,qCAAA;EA7EN;AACF;;AAoFI;EACE,sCAAA;AAjFN;;AAwFI;EACE,sCAAA;AArFN;;AA0FA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AAvFF;AA0FI;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,oBAAA;EACA,2BAAA;EACA,UAAA;AAxFN;AA2FI;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,0DAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;AAzFN;AA2FM;EACE,WAAA;EACA,yDAAA;EACA,YAAA;EACA,YAAA;AAzFR;AA4FI;;EAEE,sBAAA;AA1FN;;AA8FA;EACE,sBAAA;EACA,YAAA;AA3FF;;AA8FA;EACE,sBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3FF;;AA8FA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA3FF;;AA8FA;EACE,kBAAA;EACA,OAAA;EACA,YAAA;AA3FF;;AA8FA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;AA3FF;;AA8FA;;EAEE,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mFACE;EAEF,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,eAAA;AA7FF;;AAgGA;EACE,0CAAA;EACA,uDAAA;EACA,yBAAA;AA7FF;;AAgGA;EACE,gDAAA;EACA,wDAAA;AA7FF;;AAgGA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2DAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AA7FF;AA+FE;EACE,wCAAA;AA7FJ;;AAiGA;EACE,OAAA;EACA,0BAAA;AA9FF;;AAiGA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AA9FF;AAgGE;EACE,wCAAA;AA9FJ;;AAkGA;EACE,QAAA;EACA,0BAAA;AA/FF;;AAkGA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,kBAAA;EACA,uCAAA;EACA,uCAAA;EACA,UAAA;EACA,eAAA;AA/FF;AAiGE;EACE,2BAAA;AA/FJ;;AAmGA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AAhGF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.sensorGallery {\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  background: var(--inputs-disable-disable-surface);\n  position: relative;\n  overflow: hidden;\n  border-radius: 4px;\n  min-width: 0;\n  height: 198px;\n}\n\n.noImageGallery {\n  height: 213px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n.photoIcon {\n  width: 40px;\n  height: 40px;\n}\n\n.noImageTitle {\n  color: var(--tables-secondary-row-sub-title-text);\n  display: block;\n  text-align: center;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n}\n\n.noImageDescription {\n  display: block;\n  color: var(--tables-primary-row-text-additional);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  letter-spacing: 0.11px;\n}\n\n.twoBulletPagination {\n  :global {\n    .swiper-pagination {\n      transform: translateX(-13%) !important;\n\n      @media (max-width: 1300px) {\n        transform: translateX(-3%) !important;\n      }\n    }\n  }\n}\n\n.threeBulletPagination {\n  :global {\n    .swiper-pagination {\n      transform: translateX(-18%) !important;\n\n      @media (max-width: 1000px) {\n        transform: translateX(-6%) !important;\n      }\n    }\n  }\n}\n\n.fourBulletPagination {\n  :global {\n    .swiper-pagination {\n      transform: translateX(-23%) !important;\n    }\n  }\n}\n\n.fiveBulletPagination {\n  :global {\n    .swiper-pagination {\n      transform: translateX(-36%) !important;\n    }\n  }\n}\n\n.gallerySwiper {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n\n  :global {\n    .swiper-pagination {\n      display: flex;\n      position: absolute;\n      bottom: 0;\n      left: 50% !important;\n      transform: translateX(-50%);\n      z-index: 2;\n    }\n\n    .swiper-pagination-bullet {\n      min-width: 16px;\n      height: 3px;\n      display: block;\n      padding: 0;\n      background: var(--tables-photo-gallery-pagination-default);\n      transform: none;\n      border: none;\n      border-radius: 0;\n      box-shadow: none;\n      opacity: 1;\n      cursor: pointer;\n\n      &.swiper-pagination-bullet-active {\n        width: 11px;\n        background: var(--tables-photo-gallery-pagination-active);\n        border: none;\n        cursor: auto;\n      }\n    }\n    .swiper-pagination-bullet-active-prev-prev,\n    .swiper-pagination-bullet-active-next-next {\n      transform: scaleX(0.3);\n    }\n  }\n}\n.swiper-wrapper {\n  box-sizing: border-box;\n  height: 100%;\n}\n\n.slide {\n  box-sizing: border-box;\n  height: 144px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.galleryImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.imageItem {\n  position: relative;\n  flex: 1;\n  height: 100%;\n}\n\n.slideLabels {\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: flex-start;\n}\n\n.typeLabel,\n.pointLabel {\n  font-family: Roboto;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  padding: 5px 10px;\n  box-shadow:\n    0 0 1px 0 rgba(12, 26, 75, 0.24),\n    0 3px 8px -1px rgba(50, 50, 71, 0.05);\n  border-radius: 10px;\n  width: fit-content;\n  max-width: 100%;\n}\n\n.typeLabel {\n  color: var(--tables-primary-row-text-main);\n  background: var(--segments-chips-toggle-surface-active);\n  text-transform: uppercase;\n}\n\n.pointLabel {\n  color: var(--tables-primary-row-text-additional);\n  background: var(--segments-chips-toggle-surface-default);\n}\n\n.navBtn {\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--tables-photo-gallery-surface-arrow);\n  border: none;\n  position: absolute;\n  top: 38%;\n  z-index: 1;\n  cursor: pointer;\n\n  path {\n    stroke: var(--tables-photo-gallery-icon);\n  }\n}\n\n.prevBtn {\n  left: 0;\n  border-radius: 0 2px 2px 0;\n}\n\n.prevBtnIcon {\n  width: 20px;\n  height: 20px;\n  transform: rotate(180deg);\n\n  path {\n    stroke: var(--tables-photo-gallery-icon);\n  }\n}\n\n.nextBtn {\n  right: 0;\n  border-radius: 2px 0 0 2px;\n}\n\n.editGalleryButton {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  border-radius: 4px;\n  border: 1px solid var(--buttons-stroke);\n  background: var(--buttons-text-primary);\n  z-index: 1;\n  cursor: pointer;\n\n  path {\n    fill: var(--buttons-stroke);\n  }\n}\n\n.skeleton {\n  width: 100%;\n  height: 198px;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sensorGallery": `sensorGallery__BdoAr`,
	"noImageGallery": `noImageGallery__OCXTy`,
	"photoIcon": `photoIcon__JHreW`,
	"noImageTitle": `noImageTitle__Autcx`,
	"noImageDescription": `noImageDescription__D7kxw`,
	"twoBulletPagination": `twoBulletPagination__icK8c`,
	"threeBulletPagination": `threeBulletPagination__TDzXS`,
	"fourBulletPagination": `fourBulletPagination__hvugj`,
	"fiveBulletPagination": `fiveBulletPagination__bVLWm`,
	"gallerySwiper": `gallerySwiper__wgQYv`,
	"swiperWrapper": `swiper-wrapper__p23vF`,
	"slide": `slide__DqsPF`,
	"galleryImage": `galleryImage__Gi9xq`,
	"imageItem": `imageItem__Yj0IO`,
	"slideLabels": `slideLabels__BMU5y`,
	"typeLabel": `typeLabel__gtfbm`,
	"pointLabel": `pointLabel___sjNC`,
	"navBtn": `navBtn__aSp3o`,
	"prevBtn": `prevBtn__a2xt5`,
	"prevBtnIcon": `prevBtnIcon__obh_B`,
	"nextBtn": `nextBtn__VF3Xd`,
	"editGalleryButton": `editGalleryButton__RlMYS`,
	"skeleton": `skeleton__K9m_q`
};
module.exports = ___CSS_LOADER_EXPORT___;
